import { AppContent } from "./AppContent";
import { AppStoreProvider } from "./store/AppStoreProvider";
import { TealiumHandler } from "./TealiumHandler";
import { AlertMessageProvider } from "./contexts/AlertMessaging/context";

export const App = () => (
  <AppStoreProvider>
    <TealiumHandler>
      <AlertMessageProvider>
        <AppContent />
      </AlertMessageProvider>
    </TealiumHandler>
  </AppStoreProvider>
);
